module.exports = __webpack_public_path__ + "static/img/1_19_1.de2e2ac4.jpg";